import { render } from "./CreationForm.vue?vue&type=template&id=3ff52cd8"
import script from "./CreationForm.vue?vue&type=script&lang=js"
export * from "./CreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__